import React, { useState } from "react";
import PropTypes from "prop-types";

import { useFormikContext, Field } from "formik";

export default function Search({ placeholder = "", name }) {
  const onSearch = (e) => console.log(e);
  const { setFieldValue } = useFormikContext();

  return (
    <div className="input-field">
      <i className="material-icons prefix">search</i>
      <Field
        id={name}
        type="search"
        autoComplete="off"
        placeholder={placeholder}
        name={name}
      />
      <label className="label-icon" htmlFor={name} />
      <i
        onClick={() => setFieldValue(name, "")}
        className="material-icons fix-icon"
      >
        close
      </i>
    </div>
  );
}

Search.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
};
